import BreadCrumb, { upcomingEventBg } from "../components/BreadCrumb.jsx"
import UpcomingEventSection from "../components/UpcomingEventSection.jsx"
import EventGallary from "../components/EventGallary.jsx"
import ExpectSection from "../components/ExpectSection.jsx"


function PastEventspage() {

    return (
        <>
            <BreadCrumb 
            backgroundImage={upcomingEventBg}
            title={"Past Events"}
            description={"A look at our past programs, workshops & networking opportunities."}
            />
            <UpcomingEventSection/>
            <EventGallary/>
            <ExpectSection/>
        </>
    )
}

export default PastEventspage